(function() {
    'use strict';

    angular
        .module('wamasysApp')
        .factory('ContractDocuments', ContractDocuments);

    ContractDocuments.$inject = ['$http', 'DateUtils'];

    function ContractDocuments($http, DateUtils) {
        return {
            query: query,
            upload: upload,
            download: download,
            deleteDocument: deleteDocument
        };

        function query(contractId) {
            return $http.get('api/contrats/' + contractId + '/documents').then(function(response) {
                angular.forEach(response.data || [], normalizeDocument);
                return response.data || [];
            });
        }

        function upload(contractId, file) {
            var formData = new FormData();
            formData.append('file', file);
            return $http.post('api/contrats/' + contractId + '/documents', formData, {
                transformRequest: angular.identity,
                headers: {
                    'Content-Type': undefined
                }
            }).then(function(response) {
                return normalizeDocument(response.data);
            });
        }

        function download(contractId, documentId) {
            return $http({
                url: 'api/contrats/' + contractId + '/documents/' + documentId,
                method: 'GET',
                responseType: 'arraybuffer'
            }).then(function(response) {
                return {
                    response: new Blob([response.data], {
                        type: response.headers('Content-Type') || 'application/octet-stream'
                    }),
                    fileName: extractFileName(response.headers('Content-Disposition')) || ('document-' + documentId)
                };
            });
        }

        function deleteDocument(contractId, documentId) {
            return $http.delete('api/contrats/' + contractId + '/documents/' + documentId).then(function(response) {
                return normalizeDocument(response.data);
            });
        }

        function normalizeDocument(document) {
            if (!document) {
                return document;
            }
            document.createdDate = DateUtils.convertDateTimeFromServer(document.createdDate);
            document.lastModifiedDate = DateUtils.convertDateTimeFromServer(document.lastModifiedDate);
            document.deletedDate = DateUtils.convertDateTimeFromServer(document.deletedDate);
            return document;
        }

        function extractFileName(contentDisposition) {
            if (!contentDisposition) {
                return null;
            }
            var match = /filename=\"([^\"]+)\"/i.exec(contentDisposition);
            return match && match[1] ? match[1] : null;
        }
    }
})();
